<template>
  <div class="page-content user-detail">
    <el-breadcrumb separator="/" class="egl-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/user' }">{{ $locale("sideMenu.users.userManagement") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ breadcrumbTitle }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form class="egl-elm egl-detail" label-position="top" :model="form" :rules="formRules" ref="userDetailForm" :disabled="!editable">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('user.createUser')" prop="userName">
            <el-input
              v-model="form.userName"
              :placeholder="$locale('form.plsEnterYourUsername')"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('global.name')" prop="name">
            <el-input
              v-model="form.name"
              :placeholder="$locale('form.plsEnterYourName')"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item v-if="action == 'create'" prop="password">
            <template slot="label">
              <span>{{ $locale('global.password') }}</span>
              <el-tooltip
                placement="top"
                >
                <span class="tipIcon"></span>
                <template slot="content">
                  <p>使用できる文字種、記号：</p>
                  <p>1. A~Z, a~z, 0~9</p>
                  <p>2. !@#¥$%……^&*()_=+_~`～·《》<>,.，。？/、｜\|</p>
                  <p>使用できない文字種、記号：</p>
                  <p>1. []{} </p>
                  <p>2. 全角の文字、記号</p>
                </template>
              </el-tooltip>
            </template>
            <el-input
              type="password"
              v-model="form.password"
              autocomplete="new-passwor"
              auto-complete="new-password"
              :placeholder="$locale('form.plsEnterYourPassword')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('user.passwordAgain')" v-if="action == 'create'" prop="passwordAgain">
            <el-input
              type="password"
              v-model="form.passwordAgain"
              autocomplete="new-passwor"
              auto-complete="new-password"
              :placeholder="$locale('form.plsEnterYourPasswordAgain')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('global.email')" prop="email">
            <el-input
              v-model="form.email"
              :placeholder="$locale('form.plsEnterYourEmail')"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('user.mobileNum')" prop="mobile">
            <el-input
              v-model="form.mobile"
              :placeholder="$locale('form.plsEnterYourMobileNum')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('accountingReportDownload.dialog.personNumber')" prop="mobile">
            <el-input
              v-model="form.accountNum"
              :placeholder="$locale('accountingReportDownload.dialog.personNumber.placeholder')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$locale('user.roleAuthorization')" v-if="!form.admin" prop="roles" class="btn-group-containter">
            <el-button
              v-for="role in allRoles"
              :class="form.roles.indexOf(role.id) >= 0 ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
              @click="chooseRole(role.id)"
              :key="role.id"
            >{{ role.name }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$locale('global.cinema')" v-if="cinemaList.length > 0 && !form.admin" prop="cinemas" class="btn-group-containter">
            <el-button
              v-for="cinema in cinemaList"
              :class="form.cinemas.indexOf(cinema.id) >= 0 ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
              @click="chooseCinema(cinema.id)"
              :key="cinema.id"
            >{{ cinema.name }}</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$locale('user.personalStamp')">
            <UploadContainer
              :imageList="[form.personalStamp]"
              @onSuccess="({response}) => uploadSuccess(response)"
              @onDelete="deleteImg"
            ></UploadContainer>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
    <template v-if="isCaneditPassword()">
      <!-- reset password -->
      <el-form
        class="egl-elm  egl-detail"
        label-position="top"
        :model="resetpasswordForm"
        v-if="action === 'edit'"
        :rules="resetFormRules"
        ref="resetPasswordForm"
        :disabled="!editable"
      >
        <hr class="dotted" />
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$locale('user.oldpassword')" prop="oldPassword">
              <el-input
                v-model="resetpasswordForm.oldPassword"
                :placeholder="$locale('user.oldpassword.plsInput')"
                type="password"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item prop="newPassword">
              <template slot="label">
                <span>{{ $locale('user.newpassword') }}</span>
                <el-tooltip
                  placement="top"
                  >
                  <span class="tipIcon"></span>
                  <template slot="content">
                    <p>使用できる文字種、記号：</p>
                    <p>1. A~Z, a~z, 0~9</p>
                    <p>2. !@#¥$%……^&*()_=+_~`～·《》<>,.，。？/、｜\|</p>
                    <p>使用できない文字種、記号：</p>
                    <p>1. []{} </p>
                    <p>2. 全角の文字、記号</p>
                  </template>
                </el-tooltip>
              </template>
              <el-input
                v-model="resetpasswordForm.newPassword"
                :placeholder="$locale('user.newpassword.plsInput')"
                type="password"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$locale('user.newpassword.confirm')" prop="newPasswordConfirm">
              <el-input
                v-model="resetpasswordForm.newPasswordConfirm"
                :placeholder="$locale('user.newpassword.confirm.plsInput')"
                type="password"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- reset button -->
        <div class="reset-pw-btn">
          <el-button class="egl-btn-yellow" @click="editPassword_fn">{{ $locale("user.confirmResetPw") }}</el-button>
        </div>
        <hr class="dotted" />
      </el-form>
    </template>
      <div class="detail-page-btn">
        <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button>
        <el-button class="egl-btn-yellow" @click="save_fn" :disabled="form.roles.length === 0">{{ $locale("global.confirm") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateUser, createUser, getUserDetail, updatePasswordService } from "@/helpers/service/api/user.js";
import { getRoleList, getCinemaList } from "@/helpers/service/api/common.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
// import { localStorage } from "@/utils/localStorage";
import { emailValidator } from "@/utils/formFieldValidator";
import "@/assets/style/user.less";
import UploadContainer from "@/components/common/UploadContainer";

export default {
  name: "user-detail",
  components: {
    UploadContainer,
  },
  data() {
    return {
      editable: true,
      action: "create",
      breadcrumbTitle: this.$locale("user.createUser"),
      form: {
        userName: "",
        password: "",
        email: "",
        mobile: "",
        admin: "",
        roles: [],
        cinemas: [],
        personalStamp: "",
        name: "",
        accountNum: "",
      },
      resetpasswordForm: {
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: ""
      },
      allRoles: [],
      // passwordAgain: "",
      cinemaList: [],
      uploadUrl: "/api/system/uploadFile",
      tokenObj: {},
      imgList: [],
      resetFormRules: {
        oldPassword: [
          {
            required: true,
            message: this.$locale("login.plsEntertOldPassword"),
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: this.$locale("login.plsEntertNewPassword"),
            trigger: "blur",
          },
        ],
        newPasswordConfirm: [
          {
            required: true,
            message: this.$locale("login.plsEnterConfirmNewPassword"),
            trigger: "blur",
          },
          {
            validator: this.resetPasswordMatchValidator,
            trigger: "blur",
          },
        ],
      },
      // isAdmin: localStorage.get("isAdmin"),
      formRules: {
        userName: [ {
          required: true,
          message: this.$locale("form.plsEnterYourUsername"),
          trigger: "blur",
        } ],
        password: [ {
          required: true,
          message: this.$locale("form.plsEnterYourPassword"),
          trigger: "blur",
        } ],
        passwordAgain: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourPasswordAgain"),
            trigger: "blur",
          },
          {
            validator: this.passwordMatchValidator,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$locale("form.plsEnterYourEmail"),
            trigger: "blur",
          },
          {
            validator: emailValidator,
            trigger: "blur",
          }
        ],
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
      },
    };
  },
  methods: {
    cancel_fn() {
      this.$router.go(-1);
    },
    save_fn() {
      let obj = { ...this.form };

      this.$refs.userDetailForm.validate(valid => {
        if (valid) {
          this.saveUser(obj);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    saveUser(obj) {
      let userObj = { ...obj };

      if (userObj.id) {
        updateUser(userObj).then(res => {
          if (res.success) {
            this.countDown(this.$locale("global.updateSuccessfully"));
          }
        });
      } else {
        createUser(userObj).then(res => {
          if (res.success) {
            this.countDown(this.$locale("global.createSuccessfully"));
          }
        });
      }
    },
    getRoleList_fn() {
      const params = {
        page: 0,
        pageSize: 9999,
        status: "active",
      };

      return getRoleList(params, false, false);
    },
    getUserDetail_fn(id = "") {
      const params = {
        id: id
      };

      if (id == "") {
        return new Promise(resolve => {
          resolve({});
        });
      }
      return getUserDetail(params, false, false);
    },
    getCinemaList_fn() {
      let adminType = window.localStorage.getItem("adminType") || "";

      if (adminType == "brand") {
        return getCinemaList({ page: 0, pageSize: 9999 }, false, false);
      }
      return new Promise(resolve => {
        resolve({ data: { data: [] } });
      });

    },
    chooseRole(id) {
      // if (this.action != "detail") {
      //   let newRoles = [ ...this.form.roles ];

      //   if (this.form.roles.indexOf(id) >= 0) {
      //     newRoles.splice(newRoles.indexOf(id), 1);
      //   } else {
      //     newRoles.push(id);
      //   }

      //   this.form.roles = newRoles;
      // }
      this.form.roles = [ id ];
    },
    chooseCinema(id) {
      if (this.action != "detail") {
        let cinemas = [ ...this.form.cinemas ];

        if (cinemas.indexOf(id) >= 0) {
          cinemas.splice(cinemas.indexOf(id), 1);
        } else {
          cinemas.push(id);
        }

        this.form = { ...this.form, cinemas: [ ...cinemas ] };
      }
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({
        content: str,
        callback: () => {
          this.$router.go(-1);
        }
      });
    },
    deleteImg() {
      let obj = JSON.parse(JSON.stringify(this.form));
      obj.personalStamp = "";

      this.form = obj;
    },
    uploadSuccess(res) {
      if (res.success) {
        let obj = JSON.parse(JSON.stringify(this.form));

        obj.personalStamp = res.data;

        this.form = { ...obj };
      }
      this.imgList = [];
    },
    editPassword_fn() {
      this.$refs.resetPasswordForm.validate(valid => {
        if (valid) {
          updatePasswordService({
            id: this.form.id,
            newPassword: this.resetpasswordForm.newPassword,
            oldPassword: this.resetpasswordForm.oldPassword
          }).then(res => {
            if (res.success) {
              countDownAlert({
                content: this.$locale("global.updateSuccessfully")
              });
            }
          });
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            if (isError[0].querySelector("input")) {
              isError[0].querySelector("input").focus();
            } else {
              isError[0].querySelector("i").focus();
            }
          }, 100);

          return false;
        }
      });
    },
    resetPasswordMatchValidator(_, value, callback) {
      const that = this;

      if (value !== "") {
        if (value !== that.resetpasswordForm.newPassword) {
          callback(new Error(that.$locale("login.newPasswordDifferent")));
        } else if (value === that.resetpasswordForm.oldPassword) {
          callback(new Error(that.$locale("login.newPasswordCanNotBeTheSame")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    passwordMatchValidator(_, value, callback) {
      const that = this;

      if (value !== "") {
        if (value !== that.form.password) {
          callback(new Error(that.$locale("login.newPasswordDifferent")));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    isCaneditPassword() {
      const isAdmin = JSON.parse(window.localStorage.getItem("isAdmin"));
      const accountId = window.localStorage.getItem("accountId");
      const adminType = window.localStorage.getItem("adminType");
      if(adminType === "superAdmin") {
        return false;
      } else if (isAdmin) {
        return true;
      } else if (this.form.id === accountId) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.isCaneditPassword();
    const that = this;
    let userId = "";
    let title = that.breadcrumbTitle;
    let { action } = that;
    let { editable } = that;

    if (that.$route.params.id) {
      userId = that.$route.params.id;
      title = this.$locale("role.update");

      if (that.$route.path.split("/")[2] == "edit") {
        action = "edit";
      } else {
        action = "detail";
        editable = false;
      }
    }

    that.action = action;
    that.editable = editable;
    that.breadcrumbTitle = title;
    this.tokenObj = {
      "Authorization": window.localStorage.getItem("token"),
    };

    requestAll([
      that.getRoleList_fn(),
      that.getUserDetail_fn(userId),
      that.getCinemaList_fn()
    ]).then(res => {
      that.allRoles = [ ...res[0].data.data ];
      that.form = {
        ...that.form,
        ...res[1].data,
      };
      that.cinemaList = res[2].data.data;
    });
  },
};
</script>
<style lang="less" scoped>
.tipIcon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(../../assets/img/tipIcon.svg);
  background-size: 100% 100%;
  margin-left: 10px;
}
</style>
